import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** Gộp class Tailwind an toàn: `clsx` + `twMerge` (class sau thắng khi trùng utility). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
